// extracted by mini-css-extract-plugin
module.exports = {"HotBundles":"HotBundles_HotBundles__MqzAV"};